import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { createLogger } from "redux-logger";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { routerReducer } from "./router/slice";
import { pmaReducer } from "./pma/slice";
import { generalReducer } from "./general/slice";
import { fundReducer } from "./fund/slice";
import { faqReducer } from "./faq/slice";
import { bankReducer } from "./bank/slice";
import { deviceInfoReducer } from "./deviceInfo/slice";
import { chatbotReducer } from "./chatbot/slice";
import { profileReducer } from "./profile/slice";
import { voucherReducer } from "./voucher/slice";

const logger = createLogger();

const reducers = combineReducers({
  routerReducer,
  pmaReducer,
  generalReducer,
  fundReducer,
  faqReducer,
  bankReducer,
  deviceInfoReducer,
  chatbotReducer,
  profileReducer,
  voucherReducer,
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [
    encryptTransform({
      secretKey: "default-user",
      onError: (error) => {
        console.error("Encryption error:", error);
      },
    }),
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const isLocalhost = window.location.hostname === "localhost";

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(isLocalhost ? logger : []),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
